import { useTranslation } from 'react-i18next';
import { Alert } from '@mui/material';

import { PaymentType } from '@/services/commonTypes';

const PaymentNoticeInfo = (props: IProps) => {
  const { t } = useTranslation();

  return (
    <Alert severity="info" icon={false} sx={{ fontSize: '12px' }}>
      {t(`payment_notice.${props.paymentType}`, { company_name: props.morLegalName })}
    </Alert>
  );
};

export default PaymentNoticeInfo;

interface IProps {
  paymentType: PaymentType;
  morLegalName: string;
}
